import update from 'immutability-helper';
import { encryptionConfig } from './init.js';
import { encryptUserID } from './user.js';

async function encryptBooking(booking) {
  if (!encryptionConfig) throw Error('Encryption not initialized when encrypting booking');
  const bookingWithoutPatientID = update(booking, {
    $unset: ['patientID']
  });
  const encryptedBooking = bookingWithoutPatientID;

  if (booking.patientID) {
    const encryptedPatientID = await encryptUserID(booking.patientID);
    encryptedBooking.patientID = encryptedPatientID;
  }

  return encryptedBooking;
}

export { encryptBooking };
